import React from 'react'
import Mapa from "../components/Mapa";
import './hoteles.css'
export default function Hoteles(props) {
    function gotodir(e, pos) {
        window.open(`https://www.google.com/maps/dir/?api=1&destination=${pos.lat},${pos.lng}`, '_blank', 'noreferrer');
    }

    return (
        <section className="Invitacion-Hoteles">
            <div>
                <p><span className="block-left title-text p2">{props.title}</span></p>
                <p><span className="block-left title-text p1">{props.name}</span></p>
                <p><span className="block-left title-text p1">{props.fecha}</span></p>
                <p><span className="block-left title-text p1">{props.hora}</span></p>
                <p><span className="block-left title-text p1">{props.dir}</span></p>
            </div>
            <Mapa center={props.center} className="Hotel" icon={props.icon} marks={props.markers} />
            <div className="gps">
                {props.markers.map((m, im) => (
                    <p key={im}><span className="block-left title-text p2"><button onClick={(e) => { gotodir(e, m.pos) }}>{`Mostrar GPS para ${m.info}`}</button></span></p>
                ))}

            </div>
        </section>
    )
}
